import { categories } from '@/mocks/homeData';

const colLinks = [
  { href: '#flash', label: '实时快讯流' },
  { href: '#archive', label: '最新入档' },
  { href: '#hot', label: '今日热度榜' },
  { href: '#digest', label: '整全盘点' },
  { href: '#guide', label: '使用说明' },
];

export default function Footer() {
  return (
    <footer className="w-full bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-10 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
          {/* 品牌 */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
              </span>
              <span className="font-heading text-xl font-black text-foreground-950">扒哥黑料</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              扒哥黑料档案持续更新，收录网红主播艺人塌房备查资料。扒哥黑料汇总、整全整理与资料库动态一处归档，
              吃瓜不迷路，历史黑料一键查。
            </p>
            <p className="mt-3 text-xs text-foreground-500">
              扒哥黑料仅作公开网络信息整理备查，事件以官方通报与平台处理为准。
            </p>
          </div>

          {/* 快速栏目 */}
          <div className="md:col-span-3">
            <h4 className="text-sm font-bold text-foreground-950">本站栏目</h4>
            <ul className="mt-4 space-y-2.5">
              {colLinks.map((l) => (
                <li key={l.label}>
                  <a href={l.href} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* 分类入口 */}
          <div className="md:col-span-4">
            <h4 className="text-sm font-bold text-foreground-950">扒哥黑料资料库</h4>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-2.5">
              {categories.map((c) => (
                <li key={c.id}>
                  <a href="#category" className="inline-flex items-center gap-1.5 text-sm text-foreground-600 transition-colors hover:text-primary-700">
                    <i className="ri-arrow-right-s-line text-accent-600" aria-hidden="true"></i>
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-2 border-t border-background-200 pt-5 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 扒哥黑料 · 档案整全整理 · 汇总备查 · 资料库更新
          </p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-2">
            <a href="#top" className="inline-flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500 hover:text-foreground-950">
              <i className="ri-arrow-up-line" aria-hidden="true"></i>
              回到顶部
            </a>
            <span className="inline-flex items-center gap-1 text-xs text-foreground-500">
              <i className="ri-shield-check-line text-accent-600" aria-hidden="true"></i>
              信息留痕备查
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}